import {
    CANCEL_SCHEDULE_BOOKING_START,
    CANCEL_SCHEDULE_BOOKING_SUCCESS,
    CANCEL_SCHEDULE_BOOKING_ERROR
} from '../../constants';
import showToaster from '../../helpers/toastrMessgaes/showToaster';
import { cancelScheduleBooking as mutation, getAllBooking as query } from '../../lib/graphql/booking';
import { setLoaderStart, setLoaderComplete } from '../loader/loader';
import { closeHeaderModal } from '../siteadmin/modalActions';

export const cancelScheduleBookingAction = ({ bookingId, requestCurrency, currentPage }) => {

    return async (dispatch, getState, { client }) => {
        try {
            dispatch(setLoaderStart('cancelSchedule'));
            dispatch({ type: CANCEL_SCHEDULE_BOOKING_START });

            const { data } = await client.mutate({
                mutation,
                variables: {
                    bookingId
                },
                refetchQueries: [
                    {
                        query,
                        variables: {
                            currentPage,
                            requestType: 'upcoming',
                            requestCurrency
                        },
                    }
                ]
            });

            dispatch(setLoaderComplete('cancelSchedule'));

            if (data?.cancelScheduleBooking?.status == 200) {
                dispatch({
                    type: CANCEL_SCHEDULE_BOOKING_SUCCESS,
                });
                dispatch(closeHeaderModal('cancelScheduleBooking'));
            } else {
                dispatch({
                    type: CANCEL_SCHEDULE_BOOKING_ERROR,
                    payload: {
                        error: data?.cancelScheduleBooking?.errorMessage,
                    },
                });
                await showToaster({ messageId: 'errorMessage', toasterType: 'error', requestContent: data?.cancelScheduleBooking?.errorMessage })
            }
        } catch (error) {
            await showToaster({ messageId: 'errorMessage', toasterType: 'error', requestContent: error })
            dispatch({ type: CANCEL_SCHEDULE_BOOKING_ERROR });
            dispatch(setLoaderComplete('cancelSchedule'));
        }
    }
}
